<template>
    <div class="datCharac">
      <modal
        name="InfoModal"
        width="80%"
        height="auto"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="true"
        style="overflow:scroll"
        v-show="viewhtml"
      >
        <div class="htmlData" v-if="viewhtml" >
          <button        type="button"
              class="close"
              @click="closeModal">
                X
            </button>
          <div v-for="item of this.listHtml" :key="item.id">
            <div :id="'txt_' + item.id" v-html="item.value" v-if="item.show"/>
          </div>
        </div>
      </modal>
        <div class="titlePage">
          {{this.titleForm}}
          <router-link :to="'/admin/HistoryCharacterization/'+this.$route.params.idCaract">
            <img src="@/assets/images/DB_History.png" width="30" height="30" alt="Historial" title="Historial" class="imghistory img-fluid" v-if="historyPerson">
          </router-link>
        </div>
        <div class="detailPage" v-html="this.datCarat.DetailCharact" v-if="formList"/>
        <va-notification v-if="formListNoForm" color="danger" class="refNoData">El formulario solicitado no se encuentra activo.</va-notification>
        <va-notification v-if="formListAdd" color="info" class="refNoData">El formulario se diligencio correctamente.</va-notification>
        <va-notification v-if="formListAdd" color="info" class="refNoData"> En la IBERO continuamos comprometidos con la prevención del Covid 19, si presentas síntomas de gripa permanece en casa y solicita atención médica con EPS o comunícate con Bienestar Universitario enviando tus datos al correo bienestar.universitario@ibero.edu.co para recibir orientación. Cuando estés en la IBERO usa correctamente el tapabocas, respeta el distanciamiento de 1 mtr entre personas en todos los espacios y lava o desinfecta tus manos frecuentemente. ¡La prevención para la Salud y Seguridad es un compromiso de todos!</va-notification>
        <va-notification v-if="formListAddRestric" color="info" class="refNoData">El formulario se diligencio correctamente.</va-notification>
        <va-notification v-if="formListAddRestric" color="danger" class="refNoData">Tu reporte de salud indica vulnerabilidad ante el Covid 19. En atención a las indicaciones de prevención del Ministerio de Salud y Protección Social, te solicitamos permanecer en casa, fortalecer las medidas de prevención y usar las herramientas tecnológicas que ofrece la IBERO para estudiar.</va-notification>
        <va-notification v-if="formListsend" color="info" class="refNoData">El formulario solicitado ya se encuentra diligenciado.</va-notification>
        <div class="formPage" v-if="formList">
            <ValidationObserver ref="obsFieldsFiles">
                <FormCharact :FieldsForm="listFormCharact" :ModelForm="listFormCharactModel" :method="executeProcess" v-if="renderComponent1" />
            </ValidationObserver>
            <div class="text-right">
            <button
                id="loadForm"
                type="submit"
                v-on:click="sendForm"
                class="loginbtn primaryBtn primaryBtn"
            >Enviar</button>
            </div>
        </div>
        <div class="formPage" v-else>
          <div class="col-md-12 text-left">
              <button class="loginbtn primaryBtn primaryBtn" type="submit" v-on:click="LinkReload()">
                  <va-icon name="fa fa-arrow-left" size="60" /> Regresar
              </button>
          </div>
          <div v-for="item of this.infoHistory" :key="item.id" class="row">
            <template v-if="item.value === 'title'">
                <div class='titleRefZone col-md-12'>{{item.label}}</div>
            </template>
            <template v-else>
                <div class='LabelSumary col-md-6'>{{item.label}}</div>
                <div class='ValueSumary col-md-6' v-if="item.value === true">Si</div>
                <div class='ValueSumary col-md-6' v-else-if="item.value === false">No</div>
                <div class='ValueSumary col-md-6' v-else>{{item.value}}</div>
            </template>
          </div>
          <div class="col-md-12 text-left">
              <button class="loginbtn primaryBtn primaryBtn" type="submit" v-on:click="LinkReload()">
                  <va-icon name="fa fa-arrow-left" size="60" /> Regresar
              </button>
          </div>
        </div>
    </div>
</template>

<script>
import IberoHelpers from '@/store/helpers.js'
import FormCharact from '@/components/forms/Forms.vue'

export default {
  name: 'datCharac',
  components: {
    FormCharact,
  },
  data () {
    return {
      renderComponent1: false,
      historyPerson: false,
      datCarat: [],
      refObject: {},
      historyCarat: [],
      infoHistory: [],
      listFormCharact: [],
      listHtml: [],
      viewhtml: false,
      listFormCharactModel: {},
      formList: true,
      formListsend: false,
      formListAdd: false,
      formListAddRestric: false,
      formListNoForm: false,
      titleForm: '',
    }
  },
  methods: {
    LinkReload () {
      this.$loading.show()
      this.$router.go(this.$router.currentRoute)
    },
    sendForm () {
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsFiles.validate().then(results => {
          if (!results) {
            IberoHelpers.scrollToTop(0, 0)
            resolve(false)
          } else {
            this.refObject = {}
            let loader = this.$loading.show()
            for (var data in this.listFormCharactModel) {
              if (Array.isArray(this.listFormCharactModel[data])) {
                var coma = ''
                this.refObject[data] = ''
                for (var i = 0; i < this.listFormCharactModel[data].length; i++) {
                  if (this.listFormCharactModel[data][i] !== '') {
                    this.refObject[data] += coma + this.listFormCharactModel[data][i]
                    coma = ', '
                  }
                }
              } else if (data.indexOf('_Add') >= 1 && this.listFormCharactModel[data] !== '') {
                var newId = data.split('_')
                var idRefAdd = this.listFormCharact.findIndex(function (element) {
                  return element.id === data
                })
                if (this.refObject[newId[0] + '_' + newId[1]] === this.listFormCharact[idRefAdd].aditional) {
                  this.refObject[newId[0] + '_' + newId[1]] += ' - ' + this.listFormCharactModel[data]
                }
              } else if (this.listFormCharactModel[data] instanceof Date) {
                this.refObject[data] = IberoHelpers.dataObjDate(this.listFormCharactModel[data])
              } else if (this.listFormCharactModel[data] === true) {
                this.refObject[data] = 'Si'
              } else if (this.listFormCharactModel[data] === false) {
                this.refObject[data] = 'No'
              } else {
                this.refObject[data] = this.listFormCharactModel[data]
              }
            }
            var addCaract = IberoHelpers.addDatCaractbyId(this.$store, this.$session.get('IberoJWTAdminLogin').idPerson, this.$route.params.idCaract, this.refObject)
            addCaract.then(Response => {
              if (Response) {
                this.infoHistory.length = 0
                for (var i = 0; i < this.datCarat.FormCharact.length; i++) {
                  var valreference = ''
                  if (this.datCarat.FormCharact[i].Type_CharactForm !== 'title') {
                    valreference = this.refObject['id_' + this.datCarat.FormCharact[i].Id_CharactForm]
                  } else {
                    valreference = 'title'
                  }
                  this.infoHistory.push({ label: this.datCarat.FormCharact[i].Nam_CharactForm, value: valreference })
                }
                this.formList = false
                debugger
                // nueva validacion
                if (Response.data.message === 'Success') {
                  this.formListAdd = true
                } else if (Response.data.message === 'Restrictions') {
                  this.formListAddRestric = true
                } else {
                  this.formListAdd = true
                }

                IberoHelpers.scrollToTop(0, 0)
                resolve(true)
              } else {
                resolve(false)
              }
              loader.hide()
            })
          }
        })
      })
    },
    setObjectlist (valorum) {
      var DataArray = ''
      var infolist = []
      DataArray = valorum.split('|')
      for (var i = 0; i < DataArray.length; i++) {
        infolist.push(
          { id: DataArray[i], value: DataArray[i] }
        )
      }
      return infolist
    },
    executeHistory () {
      this.$modal.show('HistoryModal')
    },
    loadForm () {
      this.listFormCharact.length = 0
      for (var i = 0; i < this.datCarat.FormCharact.length; i++) {
        var validateRef = ''
        var validatePicker = {}
        var listData = ''
        var refRegis = 'id_' + this.datCarat.FormCharact[i].Id_CharactForm
        var Datplaceholder = this.datCarat.FormCharact[i].Nam_CharactForm

        if (this.datCarat.FormCharact[i].Det_ValidateCharactForm !== '') {
          validateRef = JSON.parse(this.datCarat.FormCharact[i].Det_ValidateCharactForm)
        }

        if (this.datCarat.FormCharact[i].Type_CharactForm === 'radio' || this.datCarat.FormCharact[i].Type_CharactForm === 'Select') {
          listData = this.setObjectlist(this.datCarat.FormCharact[i].Det_DataCharactForm)
          this.listFormCharactModel[refRegis] = ''
        } else if (this.datCarat.FormCharact[i].Type_CharactForm === 'datepicker') {
          this.listFormCharactModel[refRegis] = ''
          validatePicker.format = this.$store.state.dateFormat
          validatePicker.disabledDates = {
            to: new Date(1900, 0, 1),
            from: new Date(),
          }
        } else if (this.datCarat.FormCharact[i].Type_CharactForm === 'title') {
          this.listFormCharactModel[refRegis] = this.datCarat.FormCharact[i].Nam_CharactForm
        } else if (this.datCarat.FormCharact[i].Type_CharactForm === 'accepted') {
          Datplaceholder = this.datCarat.FormCharact[i].Det_DataCharactForm
          if (this.datCarat.FormCharact[i].Sta_AditionalCharactForm) {
            this.listHtml.push({ id: 'cbox_' + refRegis, value: this.datCarat.FormCharact[i].Det_CharactForm, show: false })
            Datplaceholder = Datplaceholder.replace('[', '<a class="linkTerm">').replace(']', '</a>')
          }
          listData = 'Si'
        } else if (this.datCarat.FormCharact[i].Type_CharactForm === 'check') {
          listData = this.setObjectlist(this.datCarat.FormCharact[i].Det_DataCharactForm)
          this.listFormCharactModel[refRegis] = []
        } else {
          this.listFormCharactModel[refRegis] = ''
        }

        this.listFormCharact.push({
          id: refRegis,
          name: this.datCarat.FormCharact[i].Nam_CharactForm,
          type: this.datCarat.FormCharact[i].Type_CharactForm,
          class: this.datCarat.FormCharact[i].Det_DataCharactClass,
          placeholder: Datplaceholder,
          values: listData,
          model: refRegis,
          validate: validateRef,
          dateTimePickerOptions: validatePicker,
          tooltip: this.datCarat.FormCharact[i].Det_CharactTooltip,
          disabled: false,
        })

        if (this.datCarat.FormCharact[i].Sta_AditionalCharactForm && this.datCarat.FormCharact[i].Type_CharactForm === 'radio') {
          var aditional = this.datCarat.FormCharact[i].Det_CharactForm.split('=')
          this.listFormCharactModel[refRegis + '_Add'] = ''
          this.listFormCharact.push({
            id: refRegis + '_Add',
            aditional: aditional[0],
            name: aditional[1],
            type: 'inputAdd',
            class: this.datCarat.FormCharact[i].Det_DataCharactClass + ' noShow',
            placeholder: aditional[1],
            values: aditional[0],
            model: refRegis + '_Add',
            validate: { required: false },
          })
        }
      }
      this.formList = true
    },
    loadData (val) {
      this.renderComponent1 = false
      var lisload = JSON.parse(val.DetPersonCharact)
      for (var i = 0; i < val.FormCharact.length; i++) {
        var keyRef = 'id_' + val.FormCharact[i].IdCharactForm
        if ((val.FormCharact[i].TypeCharactForm === 'input') || (val.FormCharact[i].TypeCharactForm === 'Select') || (val.FormCharact[i].TypeCharactForm === 'textarea')) {
          this.listFormCharactModel[keyRef] = lisload[keyRef]
        } else if (val.FormCharact[i].TypeCharactForm === 'radio') {
          var aditionInfo = lisload[keyRef].split('-')
          if (aditionInfo.length >= 2) {
            this.listFormCharactModel[keyRef] = aditionInfo[0].trim()
            var idRef = this.listFormCharact.findIndex(function (element) {
              return element.id === keyRef
            })
            this.listFormCharactModel[keyRef + '_Add'] = aditionInfo[1].trim()
            var idRefAdd = this.listFormCharact.findIndex(function (element) {
              return element.id === keyRef + '_Add'
            })
            this.listFormCharact[idRefAdd].class = this.listFormCharact[idRef].class
            this.listFormCharact[idRefAdd].validate.required = true
          } else {
            this.listFormCharactModel[keyRef] = lisload[keyRef]
          }
        } else if (val.FormCharact[i].TypeCharactForm === 'check') {
          this.listFormCharactModel[keyRef] = lisload[keyRef].split(', ')
        } else if (val.FormCharact[i].TypeCharactForm === 'datepicker') {
          var parts = lisload[keyRef].split('/')
          var mydate = new Date(parts[2], parts[1] - 1, parts[0])
          this.listFormCharactModel[keyRef] = mydate
        }
      }
      IberoHelpers.forceRerender1(this)
    },
    closeModal () {
      debugger
      this.viewhtml = false
    },
    executeProcess: function (event, refer) {
      debugger
      var infoRef = document.getElementById(event.target.name + '_Add')
      if (infoRef !== null) {
        var listData = this.listFormCharact.find(function (element) {
          return element.id === infoRef.id
        })
        if (event.target.value === infoRef.getAttribute('idvalidate')) {
          document.getElementById('div_' + event.target.name + '_Add').classList.remove('noShow')
          listData.validate.required = true
        } else {
          document.getElementById('div_' + event.target.name + '_Add').classList.add('noShow')
          listData.validate.required = false
        }
      } else {
        var findType = event.target.id.indexOf('cbox_')
        if (findType === 0) {
          this.$modal.hide('InfoModal')
          this.viewhtml = false

          this.listHtml.forEach(element => {
            if (element.id === event.target.id) {
              element.show = true
            } else {
              element.show = false
            }
          })

          this.viewhtml = true
          if (event.target.checked === true) {
            this.$modal.show('InfoModal')
          } else {
            this.listFormCharactModel[event.target.id.replace('cbox_', '')] = ''
          }
        }
      }
    },
  },
  watch: {
    historyCarat: function (val) {
      this.loadData(val)
    },
  },
  created: function () {
    let loader = this.$loading.show()
    var datCaract = IberoHelpers.getDatCaractbyId(this.$store, this.$route.params.idCaract, 2)
    datCaract.then(Response => {
      if (Response.data !== '') {
        this.datCarat = Response.data.CharacRange[0]
        if (this.datCarat.Sta_Update === false && this.historyPerson === false) {
          this.formList = false
          this.formListsend = true
        } else {
          this.loadForm()
          var datCaractPerson = IberoHelpers.getDatCaractbyIdPerson(this.$store, this.$route.params.idCaract, this.$session.get('IberoJWTAdminLogin').idPerson)
          datCaractPerson.then(Response => {
            if (Response.data) {
              this.historyCarat = Response.data.Characterizations[0]
              this.historyPerson = true
            } else {
              IberoHelpers.forceRerender1(this)
            }
            loader.hide()
          })
        }
        this.titleForm = this.datCarat.NameCharact
      } else {
        this.titleForm = 'Formulario de Caracterización'
        this.formListNoForm = true
        this.formListsend = false
        this.formList = false
      }
    })
  },
}
</script>